import React from 'react';
import columns from '../../../react-table/helpers/columns';

function determineClassName(value) {
  let className = '';
  if (value === '+') {
    className = 'bg-through-green';
  }
  if (value === '*') {
    className = 'bg-orange-amber';
  }
  return className;
}

export function getGetPropsForColumnHighlight(matrix) {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      const value = (rowInfo.row[`value${matrix.label}`]);
      className = determineClassName(value);
    }
    return {
      className,
    };
  });
}

export function carrierMailboxColumns(matrixRow, data) {
  const { AmberColorTextColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label.substring(0, 2),
      secondLine: matrix.label.substring(3, 8),
    },
    columns: [
      new AmberColorTextColumn(
        `${matrix.label.substring(0, 2)}\n${matrix.label.substring(3)}`,
        row => row.matrixRow[index].value,
        true,
      )
        .withId(`value${matrix.label}`)
        .withGetProps(getGetPropsForColumnHighlight(matrix)),
    ],
  }));
}
export function carrierNumberedMailboxColumns(matrixRow, data) {
  const { NonZeroNumberColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label.substring(0, 2),
      secondLine: matrix.label.substring(3, 8),
    },
    columns: [
      new NonZeroNumberColumn(
        `${matrix.label.substring(0, 2)}\n${matrix.label.substring(3)}`,
        row => row.matrixRow[index].value,
      )
        .withId(`value${matrix.label}`),
    ],
  }));
}
export function operatorMailboxColumns(matrixRow, data) {
  const { AmberColorTextColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label.substring(0, 3),
      secondLine: matrix.label.substring(4, 9),
    },
    columns: [
      new AmberColorTextColumn(
        `${matrix.label.substring(0, 3)}\n${matrix.label.substring(4)}`,
        row => row.matrixRow[index].value,
        true,
      )
        .withId(`value${matrix.label}`)
        .withGetProps(getGetPropsForColumnHighlight(matrix)),
    ],
  }));
}

export function operatorNumberedMailboxColumns(matrixRow, data) {
  const { NonZeroNumberColumn } = columns(data);
  return matrixRow.map((matrix, index) => ({
    Header: () => (
      <div />
    ),
    metadataForDownload: {
      firstLine: matrix.label.substring(0, 3),
      secondLine: matrix.label.substring(4, 9),
    },
    columns: [
      new NonZeroNumberColumn(
        `${matrix.label.substring(0, 3)}\n${matrix.label.substring(4)}`,
        row => row.matrixRow[index].value,
      )
        .withId(`value${matrix.label}`),
    ],
  }));
}
